;
(function($) {
  'use strict';
  const theme = {
    init: () => {
      theme.gallery();
      theme.scrollCue();
      theme.fancybox();
    },
    /**
     * Justified Gallery
     */
    gallery: () => {
      $(".justified-gallery").justifiedGallery({
        rowHeight: 400,
        margins: 30,
        border: 0,
        lastRow: 'justify',
        selector: '.item'
      });
    },
    /**
     * scrollCue
     */
    scrollCue: () => {
      function enableScrollCue() {
        scrollCue.init({
          interval: -400,
          duration: 700,
          percentage: 0.8
        });
      };
      enableScrollCue();
      scrollCue.update();
    },
    /**
     * Fancybox
     */
    fancybox: () => {
      $("[data-fancybox]").fancybox({
        idleTime : false,
        smallBtn: false, 
        hideScrollbar: false,
        loop: true,
        buttons : [
          'close'
        ],
        touch : {
          vertical : false,
          momentum : false
        },
        wheel : false
      });
    }
  }
  /**
   * Init theme core
   */
  theme.init();
})(jQuery);